import { authGet } from "@api/auth/auth";
import { DeploymentTagsResponse } from "@types";

export const fetchDeploymentTags = (
  deploymentId: string
): Promise<DeploymentTagsResponse> => {
  return authGet<DeploymentTagsResponse>(
    `/api/agent/deployments/${deploymentId}/tags`
  );
};
